/** 租户登录「记住密码」本地缓存（与 LoginModal / MainLoginPage 共用） */
const STORAGE_KEY = 'lm_tenant_login_remember_v1';

export type SavedTenantLogin = {
  teamCode: string;
  username: string;
  password: string;
};

export function loadSavedTenantLogin(): SavedTenantLogin | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    const data = JSON.parse(raw) as Partial<SavedTenantLogin>;
    if (typeof data.username !== 'string' || typeof data.password !== 'string') return null;
    return {
      teamCode: typeof data.teamCode === 'string' ? data.teamCode : '',
      username: data.username,
      password: data.password
    };
  } catch {
    return null;
  }
}

export function persistTenantLoginIfRemembered(
  remember: boolean,
  fields: { teamCode?: string; username: string; password: string }
): void {
  if (remember) {
    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        teamCode: String(fields.teamCode ?? '').trim(),
        username: fields.username,
        password: fields.password
      })
    );
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}
